import React from 'react';

import type {
  WizParsedData,
  WizRenderContext,
} from '@/sections/poe/processors/wiz/types';
import { formatKey } from '@/sections/poe/utils/formatKey';

export function renderSimpleAttributes(
  parsed: WizParsedData,
  ctx: WizRenderContext
): void {
  const { wizData, wizId, isSimpleFormat } = parsed;
  const { sections, tempTabs, mainTabKeys } = ctx;

  if (isSimpleFormat && mainTabKeys.includes('ATTRIBUTES')) {
    sections['wiz_simple_attributes'] = (
      <div className="space-y-4">
        <div className="border-chariot-stroke rounded-lg border">
          <div className="border-chariot-stroke border-b px-4 py-3">
            <h4 className="text-chariot-text-primary font-semibold">
              Cloud Resource
            </h4>
            <span className="border-chariot-stroke bg-chariot-background-secondary text-chariot-text-primary mt-2 inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium">
              Wiz ID: {wizId}
            </span>
          </div>
        </div>

        <div className="border-chariot-stroke rounded-lg border">
          <div className="border-chariot-stroke border-b px-4 py-3">
            <h4 className="text-chariot-text-primary font-semibold">
              Additional Properties
            </h4>
          </div>
          <div className="space-y-3 p-4">
            {wizData.os && (
              <div className="border-chariot-stroke flex items-start justify-between border-b py-2 last:border-b-0">
                <span className="text-chariot-text-secondary font-medium">
                  OS:
                </span>
                <span className="text-chariot-text-primary">{wizData.os}</span>
              </div>
            )}
            {wizData.cvss_base != null && (
              <div className="border-chariot-stroke flex items-start justify-between border-b py-2 last:border-b-0">
                <span className="text-chariot-text-secondary font-medium">
                  Cvss Base:
                </span>
                <span className="text-chariot-text-primary">
                  {wizData.cvss_base}
                </span>
              </div>
            )}
            {wizData.version && (
              <div className="border-chariot-stroke flex items-start justify-between border-b py-2 last:border-b-0">
                <span className="text-chariot-text-secondary font-medium">
                  Version:
                </span>
                <span className="text-chariot-text-primary">
                  {wizData.version}
                </span>
              </div>
            )}
            {wizData.fixed_version && (
              <div className="border-chariot-stroke flex items-start justify-between border-b py-2 last:border-b-0">
                <span className="text-chariot-text-secondary font-medium">
                  Fixed Version:
                </span>
                <span className="text-chariot-text-primary">
                  {wizData.fixed_version}
                </span>
              </div>
            )}
            {Object.entries(wizData)
              .filter(
                ([key]) =>
                  ![
                    'wiz_id',
                    'os',
                    'cvss_base',
                    'version',
                    'fixed_version',
                  ].includes(key)
              )
              .map(([key, value]) => (
                <div
                  key={key}
                  className="border-chariot-stroke flex items-start justify-between border-b py-2 last:border-b-0"
                >
                  <span className="text-chariot-text-secondary font-medium">
                    {formatKey(key)}:
                  </span>
                  <span className="text-chariot-text-primary">
                    {String(value)}
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
    tempTabs['ATTRIBUTES'].push({
      label: 'Resource Details',
      value: 'wiz_simple_attributes',
    });
  }
}
